import { concat } from "lodash";
import {
  validatorValidateForm,
  validatorCleanErrors,
} from "../../components/forms/validation";

export default function initValidation($) {
  if (typeof $ !== "function" || typeof $.fn !== "object") {
    // чтобы сразу видеть, что пришло
    // eslint-disable-next-line no-console
    console.error("initValidation: bad $", $);
    throw new Error("initValidation: bad jQuery");
  }

  $(function () {
    $(document).on("submit", "[data-ajax-form]", function submitAjax(e) {
      e.preventDefault();

      const $form = $(this);
      const classes = String($form.data("ajax-form") || "").split(",");
      const successSelector = $form.data("success-selector");
      const $success = successSelector ? $(successSelector) : $form;
      const successTrigger = $form.data("success-trigger");

      if (
        $form.hasClass("process") ||
        $form.hasClass("success") ||
        $form.hasClass("error")
      )
        return;

      if ($form.find('[type="email"]').val().length < 3) {
        $form.addClass("error");
        $form.find('[type="email"]').focus();
        setTimeout(() => $form.removeClass("error"), 3000);
        return;
      }

      if ($(window).width() <= window.sizes.M) {
        $("html, body").animate({ scrollTop: $form.offset().top - 15 }, 130);
      }

      $form.addClass("process");

      const sendAjax = () => {
        $.ajax({
          url: $form.attr("action"),
          data: $form.serialize(),
          type: $form.attr("method"),
          dataType: "json",
          success(data) {
            $form.removeClass("process");

            let errorsList = {};

            if (data.state === "error" || data.errors) {
              errorsList = data.errors || {};

              $form.addClass("error");

              // 1) попытаться вытащить сообщение recaptcha
              var recaptchaMsg = null;

              if (
                errorsList &&
                errorsList.MainFeedBackForm &&
                errorsList.MainFeedBackForm.recaptcha
              ) {
                recaptchaMsg = errorsList.MainFeedBackForm.recaptcha;
              } else {
                var vals = Object.values(errorsList);
                for (var k = 0; k < vals.length; k++) {
                  if (vals[k] && vals[k].recaptcha) {
                    recaptchaMsg = vals[k].recaptcha;
                    break;
                  }
                }
              }

              if (recaptchaMsg) {
                alert(recaptchaMsg);
              } else {
                $form.find("input.required").focus();
                setTimeout(function () {
                  $form.find("input.required").focus();
                }, 0);
              }

              setTimeout(function () {
                $form.removeClass("error");
                $form.find("[data-captcha-error]").fadeOut(150);
              }, 5500);

              // если хочешь — тут же можно дернуть валидатор по классам
              Object.keys(classes).forEach(function (i) {
                var cls = classes[i];
                if (errorsList[cls]) {
                  // validatorValidateForm(cls, errorsList[cls]);
                } else {
                  // validatorCleanErrors(cls);
                }
              });

              return; // ❗ критично: не продолжаем обработку
            }

            Object.keys(classes).forEach((i) => {
              const cls = classes[i];
              if (errorsList[cls]) {
                // validatorValidateForm(cls, errorsList[cls]);
              } else {
                // validatorCleanErrors(cls);
              }
            });

            if (data.state === "success") {
              $success.addClass("success");

              if (successTrigger) $(document).trigger("success");
              if ($form.data("goal")) window.goal($form.data("goal"));

              $form.trigger("reset");
              $(document).trigger("form-return");

              setTimeout(() => {
                $form[0].reset();
                $success.removeClass("success");
                $form.parents(".wrapper-form").removeClass("form-active");
                $form.find('input[name="g-recaptcha-response"]').val("");
              }, 5500);
            }
          },
          error() {
            $form.removeClass("process");
            $form.addClass("error");
            setTimeout(() => $form.removeClass("error"), 5500);
          },
        });
      };

      // --- reCAPTCHA v3 ---
      const siteKey =
        window.RECAPTCHA_SITE_KEY || "6Lc5B04sAAAAABOaN-ORaVJmZDcgO59Mvv38qUAQ";
      const action = $form.data("recaptcha-action") || "contact_form";

      if (!window.grecaptcha || !grecaptcha.ready) {
        $form.removeClass("process").addClass("error");
        setTimeout(() => $form.removeClass("error"), 5500);
        return;
      }

      grecaptcha.ready(() => {
        grecaptcha
          .execute(siteKey, { action })
          .then((token) => {
            $form.find('input[name="g-recaptcha-response"]').val(token);
            sendAjax();
          })
          .catch(() => {
            $form.removeClass("process").addClass("error");
            setTimeout(() => $form.removeClass("error"), 5500);
          });
      });

      return false;
    });
  });
}
